/// Port of mobile/lib/game/ui/death_cause_sprite.dart.

import { deathCauseVisual } from '@/game/domain/deathCauseVisual';

/// The art is authored at 1:1, so upscaling much past it turns mushy.
const maxScale = 1.1;

export function DeathCauseSprite({
  cause,
  isDark,
  maxWidth = 52,
  maxHeight = 40,
}: {
  cause: string;
  isDark: boolean;
  maxWidth?: number;
  maxHeight?: number;
}) {
  const visual = deathCauseVisual(cause, isDark);
  if (!visual) {
    return <span style={{ display: 'inline-block', width: maxWidth, height: maxHeight }} />;
  }

  const scale = Math.min(
    maxScale,
    maxWidth / visual.srcWidth,
    maxHeight / visual.srcHeight,
  );

  return (
    <span
      style={{
        display: 'inline-block',
        width: visual.srcWidth * scale,
        height: visual.srcHeight * scale,
        backgroundImage: `url(/assets/images/${visual.imagePath})`,
        backgroundRepeat: 'no-repeat',
        backgroundSize: `${visual.sheetWidth * scale}px ${visual.sheetHeight * scale}px`,
        backgroundPosition: `${-visual.srcX * scale}px ${-visual.srcY * scale}px`,
        imageRendering: 'pixelated',
      }}
    />
  );
}
